<div class="modal is-active">
  @if (isVisible) {
    <div class="modal-background" [@modalBackdropFadeAnimation]></div>
  }
  @if (isVisible) {
    <div class="modal-card" [@modalScaleInInAnimation]>
      <header class="modal-card-head">
        <p class="modal-card-title" [innerHtml]="title"></p>
      </header>
      <section class="modal-card-body">
        <ng-content />
      </section>
      <footer class="modal-card-foot">
        @if (canConfirm) {
          <button
            class="button is-info"
            [ngClass]="[confirmBtnClass, isLoading ? 'is-loading' : '']"
            (click)="onConfirmClick()"
          >
            {{ confirmBtnText }}
          </button>
        }
        @if (canCancel) {
          <button
            class="button"
            (click)="onCancelClick()"
            type="button"
            [attr.disabled]="isLoading ? 'disabled' : null"
          >
            {{ cancelBtnText }}
          </button>
        }
      </footer>
    </div>
  }
</div>
